/*
  通用变量
  全局使用
 */

/*
  通用消息加载提示消息
  应用处:
     1.获取数据
     2.查询设备状态
     3.设备控制
 */
const COMMON_LOADING_TEXT = "Loading.."

/*
  设备控制提示消息
  应用处：
    保留

*/
const DEVICE_CONTROL_TEXT = "执行中.."


const LOADING = {
  common_text: COMMON_LOADING_TEXT,
  control_text: DEVICE_CONTROL_TEXT
}



/*
  设备请求延时时间
 */
const DELAY_TIME = 100
/*
  设备控制的确认提示标题和消息
  应用处:
    确认弹窗
 */
const INFO_TITLE = "提示"
const INFO_TEXT = "确认操作吗？"
/*
  设备控制无状态时的内容
 */
const UNKNOW_STATUS_TEXT = "?"

const CONTROL = {
  delay_time: DELAY_TIME,
  info_title: INFO_TITLE,
  info_text: INFO_TEXT,
  unknow_status_text: UNKNOW_STATUS_TEXT
}

export {
  LOADING,
  CONTROL
}




// WEBPACK FOOTER //
// ./src/utils/constant.js